import { Button } from "@src/appV2/redesign/components/Button";
import { useOpenUrl } from "@src/mobile/utils/openUrl";

interface AppHandoffButtonProps {
  /** Custom-scheme URL (clipboardstaffing.facility://…) that opens the native app. */
  appSchemeUrl: string;
}

/**
 * "Open in Clipboard App" CTA shared by the magic-link confirm and email-input
 * fallback screens. Uses the custom URL scheme, which always opens the native
 * app regardless of App Link / Universal Link verification — the app then holds
 * the request-time cached email and auto-completes sign-in.
 *
 * Routes the open through `useOpenUrl` (the repo-wide helper) rather than a raw
 * `href` / `window.open`. The URL is known at click time, so the synchronous
 * variant is the correct one.
 */
export function AppHandoffButton({ appSchemeUrl }: AppHandoffButtonProps) {
  const openUrl = useOpenUrl();

  return (
    <Button
      fullWidth
      variant="primary"
      size="large"
      onClick={() => {
        void openUrl(appSchemeUrl);
      }}
    >
      Open in Clipboard App
    </Button>
  );
}
